import React from "react";
import { TableRow, TableCell, IconButton, Tooltip } from "@mui/material";
import { alpha } from "@mui/material/styles";
import ListAltOutlinedIcon from "@mui/icons-material/ListAltOutlined";
import { hasPygSerieDetalle } from "../PyGAnalitico/pygSerieDetalleConfig";

const detalleCellSx = (theme, clickable) =>
  clickable
    ? {
        cursor: "pointer",
        "&:hover": {
          backgroundColor: alpha(theme.palette.primary.main, 0.1),
          textDecoration: "underline dotted",
        },
      }
    : {};

const PygPipelineSerieDebugRow = ({
  titulo,
  resultado,
  meses,
  theme,
  formatearMiles,
  getEstiloValorEstimateHead,
  getEstiloValor1,
  onOpenDetalle,
  rowKeyPrefix,
}) => {
  const hasDetalle = hasPygSerieDetalle(titulo);
  const bg = theme.palette.background.default;

  const open = (mes, totalEsperado) => {
    if (!hasDetalle || !onOpenDetalle) return;
    onOpenDetalle(titulo, mes, totalEsperado);
  };

  return (
    <TableRow style={{ backgroundColor: bg }}>
      <TableCell
        style={{
          position: "sticky",
          left: 0,
          backgroundColor: bg,
        }}
      >
        <strong>{titulo}</strong>
        {hasDetalle ? (
          <Tooltip title="Ver detalle de líneas">
            <IconButton
              size="small"
              aria-label={`Ver detalle de ${titulo}`}
              onClick={() => open(null, resultado.total)}
              sx={{ ml: 0.5, verticalAlign: "middle" }}
            >
              <ListAltOutlinedIcon fontSize="inherit" />
            </IconButton>
          </Tooltip>
        ) : null}
      </TableCell>
      {meses.map((mes) => {
        const real = resultado[mes] || 0;
        const estimate = 0;
        const diff = real - estimate;
        const numMes = parseInt(mes, 10);

        return (
          <React.Fragment key={`${rowKeyPrefix}-${mes}`}>
            <TableCell
              align="right"
              onClick={hasDetalle ? () => open(numMes, real) : undefined}
              sx={{
                borderLeft: `1px solid ${theme.palette.pyg}`,
                ...detalleCellSx(theme, hasDetalle),
              }}
            >
              <span style={getEstiloValorEstimateHead(real)}>
                {formatearMiles(real)}
              </span>
            </TableCell>
            <TableCell align="right">
              <span style={getEstiloValor1(estimate)}>0,00</span>
            </TableCell>
            <TableCell align="right">
              <span style={getEstiloValor1(diff)}>{formatearMiles(diff)}</span>
            </TableCell>
          </React.Fragment>
        );
      })}
      <TableCell
        align="right"
        onClick={hasDetalle ? () => open(null, resultado.total) : undefined}
        sx={{
          borderLeft: `1px solid ${theme.palette.pyg}`,
          ...detalleCellSx(theme, hasDetalle),
        }}
      >
        <span style={getEstiloValorEstimateHead(resultado.total)}>
          {formatearMiles(resultado.total)}
        </span>
      </TableCell>
      <TableCell align="right">
        <span style={getEstiloValor1(0)}>0,00</span>
      </TableCell>
      <TableCell align="right">
        <span style={getEstiloValor1(resultado.total)}>
          {formatearMiles(resultado.total)}
        </span>
      </TableCell>
    </TableRow>
  );
};

export default PygPipelineSerieDebugRow;
